module.exports = {
  authComponentEvents: {
    AzureAuthenticate: {
      code: 'AZUREAUTH',
      events: {
        Signup: {
          description: 'Triggered when the digital registration is completed',
          eventHub: {
            code: 'SIGNUP',
            previousEventCode: 'ONBD-02',
            action: 'Digital registration complete',
            dataKeys: []
          },
          ga: {
            action: 'Digital registration complete'
          }
        }
      }
    }
  }
};
